import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ApplicationProviders } from '@/providers/ApplicationProviders';
import { environment } from '@/config/environment';
import { initializeI18n } from '@/i18n/initializeI18n';
import { App } from './App';
import './index.css';

initializeI18n();
document.title = environment.brandName;

function mountApplication(): void {
  const rootElement = document.getElementById('root');
  if (rootElement === null) {
    throw new Error('Root element with id "root" was not found in the document.');
  }
  createRoot(rootElement).render(
    <StrictMode>
      <ApplicationProviders>
        <App />
      </ApplicationProviders>
    </StrictMode>
  );
}

mountApplication();
